module.exports = "../fonts/IBMPlexSans-Bold.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/IBMPlexSans-Bold.ttf
// module id = 591
// module chunks = 0